<mat-sidenav-container class="client-container">
  <mat-sidenav
    class="main row marketing_details"
    #sidenav
    position="end"
    [opened]="campaignState.openCampaignStatusSheet$ | async"
    disableClose
    [fixedInViewport]="true"
    [fixedTopGap]="60"
  >
    <div class="sliding-sheet-header">
      <h4></h4>
      <button type="button" (click)="close()"><mat-icon>close</mat-icon></button>
    </div>
    <div class="client-header">
      <div class="container px-4">
        <div class="client-detail mt-3">
          <div class="row">
            <div class="col-md-6 col-4">
              <h4 class="mb-1">{{ selectedStatus?.fullName }}</h4>
            </div>
            <div class="col-md-6 col-8 float-right">
              <button mat-stroked-button color="primary" class="view-report" *ngIf="reportId" (click)="viewReport()">
                View Report
              </button>
              <button
                *ngIf="
                  !isLoading && !selectedStatus.unSubscribeAll && tableDataSource?.length != 0 && displayUnsubscribe
                "
                mat-button
                class="unsubscribeReport"
                (click)="unsubscribeReport()"
              >
                Unsubscribe
              </button>
            </div>
          </div>
          <div class="row mt-1">
            <div class="col-md-4 pr-0">
              <p class="client-dtls mb-2"><i class="material-icons">email</i>{{ selectedStatus?.email }}</p>
            </div>
            <div class="col-md-4" *ngIf="selectedStatus.phone">
              <p class="client-dtls mb-2"><i class="material-icons">phone</i>{{ selectedStatus?.phone }}</p>
            </div>
            <div class="col-md-4" *ngIf="selectedStatus?.propertyAddress">
              <p class="client-dtls mb-2"><i class="material-icons">room</i>{{ selectedStatus?.propertyAddress }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="clnt_cnt_dtls container px-4">
      <div class="row">
        <div class="col-lg-12 mt-4">
          <div class="row">
            <div class="col-lg-12">
              <div class="">
                <div class="table-responsive table_wrap">
                  <table
                    mat-table
                    [dataSource]="tableDataSource"
                    class="w-100"
                    matSort
                    matSortActive="lastActivityDate"
                    matSortDirection="desc"
                  >
                    <ng-container matColumnDef="insertedDate">
                      <th mat-header-cell *matHeaderCellDef>Emailed Date</th>
                      <td mat-cell *matCellDef="let element">{{ element.insertedDate | date }}</td>
                    </ng-container>

                    <ng-container matColumnDef="status">
                      <th mat-header-cell mat-sort-header *matHeaderCellDef>Status</th>
                      <td mat-cell *matCellDef="let element">
                        <!-- <div *ngIf="appState?.appCompanyAliasValue != 'valuetest'">
                          <div *ngIf="element.openStatus == 'unRead'" class="unread">Unread</div>
                          <div *ngIf="element.openStatus != 'unRead'" class="read">{{ element.openStatus }}</div>
                        </div> -->
                        <div>
                          <div *ngIf="element.readCount == 0 && !element.errorMessage" class="unread">Unread</div>
                          <div *ngIf="element.readCount > 0" class="read">Read</div>
                          <div *ngIf="element.errorMessage" class="unread">Not Sent</div>
                        </div>
                      </td>
                    </ng-container>

                    <ng-container matColumnDef="readCount">
                      <th mat-header-cell mat-sort-header *matHeaderCellDef>No. Of Times Read</th>
                      <td mat-cell *matCellDef="let element">
                        {{ element.readCount }}
                      </td>
                    </ng-container>

                    <ng-container matColumnDef="updatedDate">
                      <th mat-header-cell mat-sort-header *matHeaderCellDef>Last Read Dated</th>
                      <td mat-cell *matCellDef="let element">
                        {{ element.readCount == 0 ? '--' : (element.updatedDate | date) }}
                      </td>
                    </ng-container>
                    <ng-container matColumnDef="address">
                      <th mat-header-cell mat-sort-header *matHeaderCellDef>Property Address</th>
                      <td mat-cell *matCellDef="let element">
                        {{
                          element.street && element.city && element.state && element.zip
                            ? element.street + ', ' + element.city + ', ' + element.state + ', ' + element.zip
                            : '--'
                        }}
                      </td>
                    </ng-container>
                    <tr class="mat-row" *matNoDataRow>
                      <td class="mat-cell" colspan="5" style="text-align: center">No record found</td>
                    </tr>

                    <tr mat-header-row *matHeaderRowDef="tableColumnList; sticky: true"></tr>
                    <tr mat-row *matRowDef="let row; columns: tableColumnList"></tr>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </mat-sidenav>
</mat-sidenav-container>
